import Form from "react-bootstrap/Form";
import { Row, Col } from "react-bootstrap";
import FormTexts from "../../../constants/forms";
import InputGroup from "react-bootstrap/InputGroup";
import getNidInquiryStatusText from "../../../functions/extensions/getNidInquiryStatusText"
import {
  formsLabelType,
  formsButtonType,
  ModalContentType,
  NidInquiryStatusType
} from "../../../enums/index";
import { ToPersianNumber } from "../../../functions/index";
import React, { useState, useEffect, useCallback, useRef } from "react";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { ModalContainer } from "../../../shared/index";
import Urls from "../../../api/endpoints";
import { ErrorHandling, ErrorHandlingAPI } from "../../../functions/index";
import { getProvince } from "../../../api/requestAxios/userInfo";
import headings from "../../../constants/headings";
import ToUnlock from "./toUnlock";
import { validate } from "@material-ui/pickers";

const PartTwo = (props) => {

  const smsText = useRef("");
  const [show, setShow] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const [provinceList, setProvinceList] = useState([])
  const [cityAndProvince, setCityAndProvince] = useState([])
  const [cityList, setCityList] = useState([])

  const [selectedCity, setSelectedCity] = useState("")
  const [mountComponent, setMountComponent] = useState(true)
  const handleClose = (e = null, submit = null) => {
    if (e && submit) e.preventDefault();
    setShow(false);
    if (e && submit) sendSms(e);
  };
  const [whatsAppNumber, setWhatsAppNumber] = useState(null);


  const makeWhatsAppNumber = useCallback(() => {
    if (props.customer.Mobile) {
      let temp = props.customer.Mobile;
      if (temp.startsWith("0")) {
        temp = temp.slice(1);
        setWhatsAppNumber("+98" + temp);
      } else if (temp.startsWith("+98")) {
        setWhatsAppNumber(temp);
      } else {
        setWhatsAppNumber("+98" + temp);
      }
    }





  }, [props]);

  const getProv = async () => {
    try {
      const provinces = await getProvince()
      setCityAndProvince(provinces.data)
      let preProvince;
      let provinceListTemp = [];
      provinces.data.map((item, index) => {
        if (preProvince !== item.ProvinceName && !item.Delete) {
          let obj = {
            ProvinceName: '',
            Id: ''
          }
          obj.ProvinceName = item.ProvinceName;
          obj.Id = item.Id;
          provinceListTemp.push(obj)
        }
        preProvince = item.ProvinceName
        if (item.ProvinceName === props.editInfo.ProvinceName) {
          let objId = props.editInfo;
          objId.ProvinceId = item.Id;
          props.setEditInfo(objId)
        }
      })
      setProvinceList(provinceListTemp)

      var cityTemp = []
      provinces.data.map((item, index) => {
        if (item.ProvinceName === props.editInfo.ProvinceName) {
          let obj = {
            CityName: '',
            CityId: ''
          }
          obj.CityName = item.CityName;
          obj.CityId = item.CityId;
          if (item.CityName === props.editInfo.CityName) {
            setSelectedCity(item.CityId)
            let objId = props.editInfo;
            objId.CityId = item.CityId;
            props.setEditInfo(objId)
          }

          cityTemp.push(obj)
        }
      })
      cityTemp.map((item, index) => {

      })

      setCityList(cityTemp)
    } catch (error) {

    }
  }
  useEffect(() => {
    if (props.isEditMood && mountComponent) {
      getProv()

    }
    return () => {
      setMountComponent(false)
    }
  }, [props.isEditMood])


  useEffect(() => {
    makeWhatsAppNumber();
  }, [props, makeWhatsAppNumber]);




  const sendSms = (e) => {
    setSpinner(true);
    e.preventDefault();
    var passed = {
      CustomerId: props.userId,
      Text: smsText.current,
    };
    fetch(Urls.sendSms(props.userId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
      body: JSON.stringify(passed),
    })
      .then((response) => response.json())
      .then((data) => {
        setSpinner(false);
        if (!data.Success) ErrorHandlingAPI(data);
      })
      .catch((error) => {
        setSpinner(false);
        ErrorHandling(error, "send sms Error");
      });
  };

  const changeValue = (e) => {
    const { name, value } = e.target;
    if (name === 'ResidencePostalCode') {
      if (/\b(?!(\d)\1{3})[13-9]{4}[1346-9][0123-9]{5}\b/.test(value)) {
        props.setPostalCodeVliad(true)
        props.setisValidEdit(true)
      }
      else {
        props.setPostalCodeVliad(false)
        props.setisValidEdit(false)

      }
    }
    else if (name === 'HouseNumber') {
      if (/^\d+$/.test(value)) {
        props.setHouseNumberVliad(true)
        props.setisValidEdit(true)
      }
      else {
        props.setHouseNumberVliad(false)
        props.setisValidEdit(false)
      }
    }

    props.setEditInfo({ ...props.editInfo, [name]: value })

  }

  const changeProvince = (e) => {
    const { name, value } = e.target
    let cityTemp = []
    let info = { ...props.editInfo };
    info.ProvinceId = value;

    cityAndProvince.map((item, index) => {
      if (item.Id === value) {
        info.ProvinceName = item.ProvinceName
        let obj = {
          CityName: '',
          CityId: ''
        }
        obj.CityName = item.CityName;
        obj.CityId = item.CityId;

        cityTemp.push(obj)
      }
    })

    info.CityId = cityTemp[0].CityId
    info.CityName = cityTemp[0].CityName
    props.setEditInfo(info)

    setCityList(cityTemp)
  }

  const changeCity = (e) => {
    const { name, value } = e.target
    let info = { ...props.editInfo };
    info.CityId = value;
    setSelectedCity(value)
    cityList.map((item, index) => {
      if (item.CityId === value) {
        info.CityName = item.CityName
      }
    })
    props.setEditInfo(info)
  }

  return (
    <>
      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Mobile())}:
          </Form.Label>
          <InputGroup>
            <Form.Control
              className="normal-input number-input"
              type="text"
              value={
                props.customer.Mobile
                  ? props.customer.Mobile
                  : ""
              }
              onChange={() => console.log("")}
            />
            <InputGroup.Text>
              {props.customer.MobileVerificationStatus === 1 ? (
                <FontAwesomeIcon
                  className="verified has-whats-app no-action"
                  icon={faCheckCircle}
                />
              ) : props.customer.MobileVerificationStatus === 2 ? (
                <FontAwesomeIcon
                  className="not verified has-whats-app no-action"
                  icon={faExclamationCircle}
                />
              ) : (
                ""
              )}
              {props.customer.Mobile && whatsAppNumber && (
                <a
                  href={`//api.whatsapp.com/send?phone=${whatsAppNumber}&text=`}
                  className="whats-app-link"
                  target="blank"
                >
                  <FontAwesomeIcon
                    className="verified has-whats-app"
                    icon={faWhatsapp}
                  />
                </a>
              )}
              {props.customer.LockStatusMobile && <ToUnlock actionType={"mobile"} id={props.customer.Id} />}
              {props.customer.Mobile &&
                (spinner ? (
                  <span
                    className="send-sms-btn"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    <FontAwesomeIcon icon={faSpinner} spin />
                  </span>
                ) : (
                  <span
                    className="send-sms-btn"
                    onClick={() => {
                      setShow(true);
                    }}
                  >
                    {FormTexts.Buttons(formsButtonType.SendSms())}
                  </span>
                ))}
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>



        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Email())}:
          </Form.Label>
          <InputGroup>
            <Form.Control
              className="normal-input"
              type="email"
              value={props.customer.Email ? props.customer.Email : ""}
              onChange={() => console.log("")}
            />
            {/* <ToUnlock actionType={"email"} id={props.customer.id} style={{ marginTop: '5px' }} /> */}

            <InputGroup.Text>
              {props.customer.EmailVerificationStatus === 1 ? (
                <FontAwesomeIcon
                  className="verified  has-whats-app no-action"
                  icon={faCheckCircle}
                />
              ) : props.customer.EmailVerificationStatus === 2 ? (
                <FontAwesomeIcon
                  className="not verified  has-whats-app no-action"
                  icon={faExclamationCircle}
                />
              ) : (
                ""
              )}
            </InputGroup.Text>
          </InputGroup>
        </Form.Group>


      </Row>



      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Phone())}:
          </Form.Label>
          <Form.Control
            className="normal-input"
            type="text"
            value={
              props.customer.Phone ? ToPersianNumber(props.customer.Phone) : ""
            }
            onChange={() => console.log("")}
          />
        </Form.Group>


        <Form.Group as={Col}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.PostalCode())}:
          </Form.Label>
          <div className="postal-code-holder">
            {props.isEditMood && <Form.Control
              className={props.isEditMood ? 'user-info-from' : 'normal-input'}
              type="text"
              value={props.editInfo.ResidencePostalCode ? props.editInfo.ResidencePostalCode : ""}
              name="ResidencePostalCode"
              onChange={(e) => changeValue(e)}
              disabled={!props.isEditMood}
            />}
            {!props.isEditMood && <Form.Control
              className={'normal-input'}
              type="text"
              value={props.editInfo.ResidencePostalCode ? props.editInfo.ResidencePostalCode : ""}
              name="ResidencePostalCode"
              onChange={(e) => changeValue(e)}
              disabled={!props.isEditMood}
            />}


            {!props.postalCodeVliad && props.isEditMood && <FontAwesomeIcon
              className="postalCode-icon-holder"
              icon={faExclamationCircle}
            />}
          </div>

        </Form.Group>


      </Row>



      <Row className="mb-2">
        <Form.Group as={Col} className={`${props.isEditMood ? 'd-flex flex-row ' : ''}`} style={{ marginTop: '20px' }}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Province())}:
          </Form.Label>
          {!props.isEditMood && <Form.Control
            className='normal-input'
            type="text"
            value={
              props.editInfo.ProvinceName ? props.editInfo.ProvinceName : ""
            }
            name="Province"
            onChange={(e) => changeValue(e)}
            disabled={!props.isEditMood}
          />
          }
          {props.isEditMood && <select
            className='user-info-from-select'
            name="ProvinceId"
            onChange={(e) => { changeProvince(e) }}>

            <option value={props.editInfo.ProvinceName ? props.editInfo.ProvinceName : headings.PLEASE_SELECTION}>{props.editInfo.ProvinceName ? props.editInfo.ProvinceName : headings.PLEASE_SELECTION}</option>
            {provinceList.map((item, index) => {
              return <option key={item.Id} value={item.Id} >{item.ProvinceName}</option>
            })
            }
          </select>
          }
        </Form.Group>
        <Form.Group as={Col} className={`${props.isEditMood ? 'd-flex flex-row ' : ''}`} style={{ marginTop: '20px' }}>
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.City())}:
          </Form.Label>
          {!props.isEditMood && <Form.Control
            className={props.isEditMood ? 'user-info-from ' : 'normal-input'}
            type="text"
            value={
              props.editInfo.CityName ? props.editInfo.CityName : ""
            }
            name="City"
            onChange={(e) => changeValue(e)}
            disabled={!props.isEditMood}
          />}
          {props.isEditMood && <select
            name="CityId"
            className='user-info-from-select  user-info-from-select-city'
            onChange={(e) => { changeCity(e) }}
            value={selectedCity}>

            {cityList.length === 0 && <option value={props.editInfo.CityName ? props.editInfo.CityName : headings.PLEASE_SELECTION}>{props.editInfo.CityName ? props.editInfo.CityName : headings.PLEASE_SELECTION}</option>}
            {cityList.map((item, index) => {
              return <option key={item.CityId} value={item.CityId} >{item.CityName}</option>
            })
            }
          </select>
          }
        </Form.Group>
      </Row>


      <Row className="mb-2">
        <Form.Group as={Col}>
          <Form.Label className="input-label" style={{ paddingTop: '0px' }}>
            {FormTexts.Labels(formsLabelType.Street())}:
          </Form.Label>
          <div className='user-info-form-validate'>
            {<Form.Control
              style={{ paddingTop: '0px' }}
              className={props.isEditMood ? 'user-info-from' : 'normal-input'}
              type="text"
              rows={3}
              as="textarea"
              value={
                props.editInfo.ResidenceAddress
                  ? props.editInfo.ResidenceAddress
                  : ""
              }
              name="ResidenceAddress"
              onChange={(e) => changeValue(e)}
              disabled={!props.isEditMood}
            />}
            {props.isEditMood && !props.editInfo.ResidenceAddress && <FontAwesomeIcon
              className="user-info-form-validate-icon-left-street"
              icon={faExclamationCircle}
            />}
          </div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label className="input-label" style={{ fontSize: '13px', paddingTop: '3px' }}>
            {FormTexts.Labels(formsLabelType.Alley())}:
          </Form.Label>
          <div className='user-info-form-validate'>
            {<Form.Control
              style={{ paddingTop: '0px' }}
              className={props.isEditMood ? 'user-info-from' : 'normal-input'}
              type="text"
              value={
                props.editInfo.Street ? props.editInfo.Street : ""
              }
              name="Street"
              onChange={(e) => changeValue(e)}
              disabled={!props.isEditMood}
            />}
            {props.isEditMood && !props.editInfo.Street && <FontAwesomeIcon
              className="user-info-form-validate-icon-left"
              icon={faExclamationCircle}
            />}
          </div>
        </Form.Group>
      </Row>

      <Row className="mb-2">
        <Form.Group as={Col} >
          <Form.Label className="input-label">
            {FormTexts.Labels(formsLabelType.Plaque())}:
          </Form.Label>
          <div className='user-info-form-validate'>
            {<Form.Control
              className={props.isEditMood ? 'user-info-from ' : 'normal-input'}
              type="text"
              value={
                props.editInfo.HouseNumber
                  ? props.editInfo.HouseNumber
                  : ""
              }
              name="HouseNumber"
              onChange={(e) => changeValue(e)}
              disabled={!props.isEditMood}
            />}
            {props.isEditMood && !props.houseNumberVliad && <FontAwesomeIcon
              className="user-info-form-validate-icon"
              icon={faExclamationCircle}
            />}
          </div>

        </Form.Group>
      </Row>










      <ModalContainer
        show={show}
        type={ModalContentType.SendSms()}
        title={FormTexts.Buttons(formsButtonType.SendSms())}
        handleClose={handleClose}
        data={smsText}
      ></ModalContainer>
    </>
  );
};
export default PartTwo;
